/* AUTO-GENERATED from config/supreme-game-engines.v10.json. DO NOT HAND EDIT. */
export const SUPREME_ENGINE_CONTRACT_HASH='9f6cad923c3dfd7b41ddc974fbf62188836f4f5928886ebb362ba388c4777838' as const
export const SUPREME_ENGINE_PROFILE={
  "schema": "INYRON_SUPREME_GAME_ENGINES_V1",
  "revision": 10,
  "effectiveDate": "2026-09-18",
  "principle": "One tuning contract, sovereign game adapters, no duplicated gameplay authority.",
  "engines": [
    {
      "id": "animation-integrity",
      "name": "Animation Integrity",
      "tuning": {
        "quarantinedClips": [
          "attack_swing_alt"
        ],
        "minPlaybackRate": 0.55,
        "maxPlaybackRate": 1.55,
        "minCrossfade": 0.025,
        "maxCrossfade": 0.22
      }
    },
    {
      "id": "motion-continuity",
      "name": "Motion Continuity",
      "tuning": {
        "minScale": 0.35,
        "maxScale": 2.4,
        "maxPresentationOffset": 3,
        "maxPresentationY": 3.5,
        "maxAngularOffset": 3.141593
      }
    },
    {
      "id": "frame-pacing",
      "name": "Frame Pacing",
      "tuning": {
        "targetFps": 60,
        "sampleWindowSeconds": 5,
        "qualityStepCooldownSeconds": 4,
        "minDpr": 1,
        "maxDpr": 1.5
      }
    },
    {
      "id": "camera-guardian",
      "name": "Camera Guardian",
      "tuning": {
        "minFov": 32,
        "maxFov": 72,
        "minNear": 0.04,
        "maxNear": 0.25,
        "minFar": 100,
        "maxCameraDistance": 42
      }
    },
    {
      "id": "contact-fidelity",
      "name": "Contact Fidelity",
      "tuning": {
        "pulseLifetime": 0.32,
        "maxPulse": 1.6,
        "criticalMultiplier": 1.35,
        "specialMultiplier": 1.5
      }
    },
    {
      "id": "destruction-cinematics",
      "name": "Destruction Cinematics",
      "tuning": {
        "burstLifetime": 1.1,
        "maxFragments": 18,
        "collapsedMultiplier": 1.55,
        "brokenMultiplier": 1.15
      }
    },
    {
      "id": "atmosphere-cohesion",
      "name": "Atmosphere Cohesion",
      "tuning": {
        "combatLightBoost": 2.4,
        "impactLightBoost": 5.5,
        "maxPulseSeconds": 0.8
      }
    },
    {
      "id": "character-readability",
      "name": "Character Readability",
      "tuning": {
        "keyIntensity": 1.1,
        "combatBoost": 1.65,
        "criticalHealthBoost": 0.8,
        "lightDistance": 6
      }
    },
    {
      "id": "sonic-dynamics",
      "name": "Sonic Dynamics",
      "tuning": {
        "thresholdDb": -20,
        "kneeDb": 16,
        "ratio": 4,
        "attack": 0.006,
        "release": 0.18,
        "transientGain": 0.018
      }
    },
    {
      "id": "material-asset-sentinel",
      "name": "Material & Asset Sentinel",
      "tuning": {
        "scanIntervalSeconds": 2,
        "maxAnisotropy": 8,
        "minRoughness": 0.08,
        "maxRoughness": 1,
        "minEnvIntensity": 0.2,
        "maxEnvIntensity": 3
      }
    }
  ]
} as const
export type SupremeEngineId=typeof SUPREME_ENGINE_PROFILE.engines[number]['id']
export type SupremeEngineById<I extends SupremeEngineId>=Extract<typeof SUPREME_ENGINE_PROFILE.engines[number],{id:I}>
export function supremeEngine<I extends SupremeEngineId>(id:I):SupremeEngineById<I>{return SUPREME_ENGINE_PROFILE.engines.find((engine)=>engine.id===id) as SupremeEngineById<I>}
